import { RowData } from "./types";

export const tagsCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data || !data.isOrganizer) {
        return null;
    }

    const { tags } = data.item.purchase;
    const ids = tags ? tags.map((tag) => tag.id) : [];

    const formattedTagsString = ids.join(", ");

    return ids ? formattedTagsString : null;
};

export const TagsCellFormatter = ({ value }: { value: string | null }) => value ?? "";
